import { useTheme } from "lib/theme";
import { ColorName } from "lib/theme/themes/app-theme";
import { ComponentType, ReactNode } from "react";
import typography from "./typography";

export type TextType = keyof typeof typography;

export function Text(props: {
  type: TextType;
  className?: string;
  as?: string | ComponentType<any>;
  color?: ColorName;
  children: ReactNode;
}) {
  const { type, color, ...rest } = props;
  const Component = typography[type];

  const theme = useTheme();

  const style = color ? { color: theme.app.colors[color] } : undefined;

  return (
    <Component style={style} {...rest}>
      {props.children}
    </Component>
  );
}
